/**
 * Custom Delivery Estimator — Sam's Store UAE
 * Upgraded: business-day aware, arrival date calc, localStorage persistence
 */

const DELIVERY_DATA = {
  dubai: { min: 1, max: 2, label: 'Dubai' },
  sharjah: { min: 1, max: 2, label: 'Sharjah' },
  ajman: { min: 1, max: 2, label: 'Ajman' },
  abudhabi: { min: 2, max: 3, label: 'Abu Dhabi' },
  rasalkhaimah: { min: 3, max: 5, label: 'Ras Al Khaimah' },
  fujairah: { min: 3, max: 4, label: 'Fujairah' },
  ummAlQaiwain: { min: 3, max: 4, label: 'Umm Al Qaiwain' },
};

/**
 * Add business days, skipping UAE weekends (Friday=5, Saturday=6)
 */
function addBusinessDays(date, days) {
  const result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay();
    if (day !== 5 && day !== 6) added++;
  }
  return result;
}

function formatDate(date) {
  return date.toLocaleDateString('en-AE', { weekday: 'short', day: 'numeric', month: 'short' });
}

function buildResult(city) {
  const data = DELIVERY_DATA[city];
  if (!data) return '';
  const today = new Date();
  const earliest = addBusinessDays(today, data.min);
  const latest = addBusinessDays(today, data.max);
  if (data.min === data.max) {
    return `🚚 <strong>${data.label}</strong>: <strong>${data.min} Business Day${data.min > 1 ? 's' : ''}</strong><br>📅 Arrives by <strong>${formatDate(latest)}</strong>`;
  }
  return `🚚 <strong>${data.label}</strong>: <strong>${data.min}–${data.max} Business Days</strong><br>📅 Arrives by <strong>${formatDate(latest)}</strong>`;
}

function initDeliveryEstimators() {
  const selects = document.querySelectorAll('.delivery-city-select, [data-delivery-select], .state-select');
  if (!selects.length) return;

  const savedCity = localStorage.getItem('sams_delivery_city') || '';

  selects.forEach(function (select) {
    // Restore saved city
    if (savedCity && select.querySelector('option[value="' + savedCity + '"]')) {
      select.value = savedCity;
    }

    // Find closest result container
    function getResultEl() {
      const wrapper = select.closest('.delivery-estimator-widget, .delivery-time-selector, [data-delivery-widget]');
      if (wrapper) return wrapper.querySelector('.delivery-result, [data-delivery-result]');
      // Fallback: sibling
      return select.parentNode.querySelector('.delivery-result, [data-delivery-result]');
    }

    function updateResult() {
      const city = select.value;
      const resultEl = getResultEl();
      if (!resultEl) return;
      if (!city) {
        resultEl.innerHTML = '';
        resultEl.style.display = 'none';
        return;
      }
      const html = buildResult(city);
      if (html) {
        resultEl.innerHTML = html;
        resultEl.style.display = 'block';
        localStorage.setItem('sams_delivery_city', city);
      }
    }

    select.addEventListener('change', updateResult);

    // Auto-show if city already selected
    if (select.value) {
      updateResult();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDeliveryEstimators);
} else {
  initDeliveryEstimators();
}
